import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';


@Component({})
export default class EditProblem extends Vue {
    private $api: any;
    private $cookie: any;
    private problem: string = '';
    private isDisabled: boolean = true;


    // 没有数据输入回车使按钮无效
    private isEnter() {
        if (this.problem.trim().length === 0 || this.problem === ' ' || this.problem === null || this.problem === undefined) {
            this.isDisabled = true;
        }
    }
    @Watch('problem') private watchProblem(newValue: any, oldValue: any) {
        // console.log(newValue + 'gahgdfhd' +  oldValue);
        if (this.problem.split(' ').join('').length === 0 || this.problem === '' || this.problem === null || this.problem === undefined) {
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
        }
    }
    private async submitProblem() {
        this.isDisabled = true;
        // 问题反馈：1，上级反馈：2
        const item = this.$route.params.index;
        const Cid = this.$route.params.infoId;
        const model = {
            id: Cid,
            msg: this.problem,
        };
        if (item === '1') {
            const data = await this.$api.httpPost('membership/Monthlysummary/IPostMonthlysummarySubfeedback', model);
            if (data.Success) {
                this.$toast.success('提交成功');
                setTimeout(() => {
                    this.$router.go(-1);
                }, 2000);
            } else {
                this.isDisabled = false;
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: data.AllMessages,
                });
            }
        } else if (item === '2') {
            const data = await this.$api.httpPost('membership/Monthlysummary/IPostMonthlysummaryLeaderSubfeedback', model);
            if (data.Success) {
                this.$toast.success('提交成功');
                setTimeout(() => {
                    this.$router.go(-1);
                }, 2000);
            } else {
                this.isDisabled = false;
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: data.AllMessages,
                });
            }
        }
    }
}
